import { PageOuterContainer } from '../../../root-components/layouts/page-outer-container'
import { PageTitle } from '../../presentation-components/display-elements-components/page-title'

export const PartnerDashboardPage = () => {
  return (
    <PageOuterContainer>
      <PageTitle title='Partner Dashboard' />
    </PageOuterContainer>
    )
}